import React from "react";
import { Link } from "react-router-dom";
import whiteLogo from "../Assets/logo-white.png";
import { dashboardPath, scrollIfSamePage, signedIn } from "./session";
import { EmailIcon, FacebookIcon, InstagramIcon } from "./SocialIcons";

const SiteFooter = () => {
  const member = signedIn();
  return (
  <footer>
    <div className="wrap">
      <div className="grid">
        <div>
          <img className="flogo" src={whiteLogo} alt="Feis.link" />
          <p className="tag">Feis registration, tabulation and results for Irish dance since 2019.</p>
        </div>
        <div>
          <h4>Families</h4>
          <ul>
            <li><Link to={member ? "/" : "/#events"} onClick={scrollIfSamePage(member ? "/" : "/#events")}>Events</Link></li>
            <li><Link to="/results">Results</Link></li>
            {member ? (
              <li><Link to={dashboardPath()}>My dashboard</Link></li>
            ) : (
              <>
                <li><Link to="/signup">Create an account</Link></li>
                <li><Link to="/login">Log in</Link></li>
              </>
            )}
          </ul>
        </div>
        <div>
          <h4>Organisers</h4>
          <ul>
            <li><Link to="/organisers">For organisers</Link></li>
            <li><Link to="/organisers#pricing" onClick={scrollIfSamePage("/organisers#pricing")}>Pricing</Link></li>
            {!member && <li><Link to="/login-org">Organiser log in</Link></li>}
          </ul>
        </div>
        <div>
          <h4>Feis.link</h4>
          <ul>
            <li><Link to="/about">About</Link></li>
            <li><a className="soc-link" href="mailto:info@feis.link"><EmailIcon />info@feis.link</a></li>
            <li><a className="soc-link" href="https://www.instagram.com/feis.link" target="_blank" rel="noopener noreferrer"><InstagramIcon />Instagram</a></li>
            <li><a className="soc-link" href="https://www.facebook.com/feis.link" target="_blank" rel="noopener noreferrer"><FacebookIcon />Facebook</a></li>
          </ul>
        </div>
      </div>
      <div className="legal">
        <span>© {new Date().getFullYear()} Feis.link · Wheatley, Ontario</span>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
      </div>
    </div>
  </footer>
  );
};

export default SiteFooter;
